// @flow

import React from 'react'
import { useSelector } from 'react-redux'
import { isMobile } from 'react-device-detect'
import { LoadingAnimation, HeroBanner } from '../../components'
import ReactHtmlParser from 'react-html-parser'
import { useTranslation } from '../../hooks'
import { HISTORY, ROUTE_CONSTANTS } from '../../utils'

function AboutUs() {
	const translate = useTranslation()
	const { showLoadingScreen } = useSelector((state) => state.loading)
	const { networkAvailable } = useSelector((state) => state.toast)
	const { additional_details } = useSelector((state) => state.config)
	const { about_us } = additional_details || {}

	return (
		<div className={`aboutWrap ${!networkAvailable ? 'noEvents' : ''}`}>
			{showLoadingScreen ? (
				<LoadingAnimation />
			) : (
				<>
					<HeroBanner
						text={about_us?.hero?.text}
						logo_One={about_us?.logo}
						heroBanner={about_us?.hero?.image}
					/>
					<div className="aboutContent">
						<div className="container">
							<div className="row">
								<div className="col-md-12 col-sm-12">
									<div className="content">
										{!isMobile ? (
											<div className="sideImg about ">
												<img src={`${about_us?.content?.image}`} alt="img" />
											</div>
										) : (
											''
										)}
										<div className="description privacyContent">
											<h1>{translate('GENERAL.ABOUT_US')}</h1>
											<div>{ReactHtmlParser(about_us?.content?.text)}</div>
										</div>
										{isMobile ? (
											<div className="sideImg about ">
												<img src={`${about_us?.content?.image}`} alt="img" />
											</div>
										) : (
											''
										)}
									</div>
								</div>
							</div>
						</div>
						<footer className="footer">
							<div className="container">
								<div className="row">
									<div className="col-sm-12">
										<div className="mainFooter">
											<ul className="left">
												<li onClick={() => HISTORY.push(ROUTE_CONSTANTS.PRIVACY_POLICY)}>
													<i className="icons-icon-guard"></i>
													<span>{translate('GENERAL.PRIVACY_POLICY')}</span>
												</li>
											</ul>
											<ul className="right">
												<li>
													<i className="icons-icon-phone"></i>
													<a href={`tel:${about_us?.phone_number}`}>{about_us?.phone_number}</a>
												</li>
												<li>
													<i className="icons-icon-mail"></i>
													<a href={`mailto:${about_us?.email}`}>{about_us?.email}</a>
												</li>
											</ul>
										</div>
									</div>
								</div>
							</div>
						</footer>
					</div>
					<div className="aboutContent d-none">
						<div className="container">
							<div className="row">
								<div className="">
									<div className="content">
										<div className="description ">
											<div className="sideImg about d-none d-md-block">
												<img src={about_us?.content?.image} alt="img" />
											</div>
											<h1>{translate('GENERAL.ABOUT_US')}</h1>
											<p>{ReactHtmlParser(about_us?.content?.text)}</p>
										</div>
									</div>
								</div>
								<div className="col-sm-12 d-md-none d-sm-block">
									<div className="sideImg about">
										<img src={about_us?.content?.image} alt="img" />
									</div>
								</div>
							</div>
						</div>
						<footer className="footer">
							<div className="container">
								<div className="row">
									<div className="col-sm-12">
										<div className="mainFooter">
											<ul className="left">
												<li onClick={() => HISTORY.push(ROUTE_CONSTANTS.PRIVACY_POLICY)}>
													<i className="icons-icon-guard"></i>
													<span>{translate('GENERAL.PRIVACY_POLICY')}</span>
												</li>
											</ul>
											<ul className="right">
												<li>
													<i className="icons-icon-phone"></i>
													<a href={`tel:${about_us?.phone_number}`}>{about_us?.phone_number}</a>
												</li>
												<li>
													<i className="icons-icon-mail"></i>
													<a href={`mailto:${about_us?.email}`}>{about_us?.email}</a>
												</li>
											</ul>
										</div>
									</div>
								</div>
							</div>
						</footer>
					</div>
				</>
			)}
		</div>
	)
}

export default AboutUs
